/* QLMD password page "Qualmedie Tennis Club" — countdown, password field feedback, imprint dialog.
   Pattern: FLGNTLT password-paris (countdown phases, throttled reload, no simulated "welcome"). */
(function () {
  'use strict';

  var root = document.querySelector('.qt[data-qt]');
  if (!root) return;

  // ── Countdown ───────────────────────────────────────────────────────────────────────
  // Hours are not folded into days (FLGNTLT CEO: no day block). Once the opening time has passed,
  // the status switches and the page reloads every 30 s (max 20 per tab): as soon as the password
  // falls, /password forwards to the shop and waiting members get in by themselves.
  var cd = document.getElementById('qtCd');
  var status = document.getElementById('qtStatus');
  if (cd) {
    var start = new Date(cd.getAttribute('data-release')).getTime();
    var liveText = cd.getAttribute('data-live') || '';
    var elH = document.getElementById('qtH');
    var elM = document.getElementById('qtM');
    var elS = document.getElementById('qtS');
    var timer = null;
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };

    var tick = function () {
      var diff = start - Date.now();
      if (diff > 0) {
        var t = Math.floor(diff / 1000);
        elH.textContent = pad(Math.floor(t / 3600));
        elM.textContent = pad(Math.floor(t / 60) % 60);
        elS.textContent = pad(t % 60);
        return;
      }
      if (timer) clearInterval(timer);
      root.classList.add('is-live');
      if (status && liveText) status.textContent = liveText;
      try {
        var n = parseInt(sessionStorage.getItem('qlmd_pw_reloads') || '0', 10);
        if (n < 20) {
          sessionStorage.setItem('qlmd_pw_reloads', String(n + 1));
          setTimeout(function () { location.reload(); }, 30000);
        }
      } catch (e) {
        console.error('[qlmd-tennis] reload counter unavailable (private mode?)', e);
      }
    };

    // An invalid date must not show a NaN countdown: hide it, the status line stays.
    if (isNaN(start)) {
      cd.hidden = true;
      console.error('[qlmd-tennis] invalid release_date', cd.getAttribute('data-release'));
    } else {
      tick();
      if (!root.classList.contains('is-live')) timer = setInterval(tick, 1000);
    }
  }

  // ── Password field ──────────────────────────────────────────────────────────────────
  // The client cannot check the password, so no fake welcome: a pending text while the browser
  // posts, a nudge + focus when Shopify answers with an error.
  var gate = document.getElementById('qtGate');
  if (gate) {
    var form = gate.querySelector('form');
    var enter = document.getElementById('qtEnter');
    var feld = document.getElementById('qtPw');
    if (form) {
      form.addEventListener('submit', function () {
        gate.classList.add('is-wartend');
        if (enter) {
          // disabled would drop the button from the POST — only lock it visually.
          enter.setAttribute('aria-busy', 'true');
          enter.style.opacity = '.6';
          enter.style.pointerEvents = 'none';
        }
      });
    }
    if (gate.querySelector('[data-error]')) {
      gate.classList.add('is-falsch');
      if (feld) { feld.value = ''; feld.focus(); }
      setTimeout(function () { gate.classList.remove('is-falsch'); }, 600);
    }
  }

  // ── Imprint dialog ──────────────────────────────────────────────────────────────────
  var dialog = document.getElementById('qtImpressum');
  var oeffner = document.querySelector('[data-qt-impressum]');
  if (dialog && oeffner && typeof dialog.showModal === 'function') {
    oeffner.addEventListener('click', function () { dialog.showModal(); });
    // A click on the backdrop lands on the <dialog> itself — close it like Escape does.
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () { oeffner.focus(); });
  }
})();
